import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { useSupporterVoicesButton } from './hooks/useSupporterVoicesButton';

type Props = {
	text: string;
	addVoiceInProgress: boolean;
	shareVoice: (text: string) => void;
};

export const SupporterVoicesButton: React.FC<Props> = ({ text, addVoiceInProgress, shareVoice }) => {
	const {
		data: { buttonTextCopy, buttonTextGuestCopy, currentUser },
		actions: { handleLoginButtonClick, handleAddVoiceButtonClick },
	} = useSupporterVoicesButton({ text, shareVoice });

	return currentUser ? (
		<Button
			variant="primary"
			className="w-full md:w-1/2"
			onClick={handleAddVoiceButtonClick}
			loading={addVoiceInProgress}
			data-loading={addVoiceInProgress ? 'true' : 'false'}
			data-testid="add-supporter-voice-button"
			data-qa="add-supporter-voice-button"
		>
			{buttonTextCopy}
		</Button>
	) : (
		<Button
			data-testid="login"
			data-qa="login"
			variant="primary"
			className="w-full md:w-1/2"
			onClick={handleLoginButtonClick}
		>
			{buttonTextGuestCopy}
		</Button>
	);
};
